/**
 * shadcn/ui v4 preset data — thin re-export of @cogo/design-presets.
 *
 * Moved 2026-04-16 to break the cogo-studio → cogo-react-renderer-v2
 * dependency direction. The renderer needs `lookupPreset` to derive
 * themeTokens from `design-system.json::axes` at runtime; importing it
 * from a Studio-internal path is forbidden, so the canonical table
 * now lives in `packages/cogo-design-presets`. This file remains as a
 * stable import surface for existing Studio code (BlockGridTestPage,
 * design-system-preview, etc.).
 */

export * from '@cogo/design-presets'
